import { all } from "redux-saga/effects"
import applicationFormSaga from "./applicationForm"
import toolSaga from "./tool"

export default function* rootSaga() {
  yield all([...applicationFormSaga, ...toolSaga])
}
